import { render } from "./TickIcon.vue?vue&type=template&id=6b7e6ffa"
const script = {}

import exportComponent from "/home/appfloretcollegein/app.floretcollege.in/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__